export default {
  path: '/macro_types',
  name: 'macro_types',
  component: () => import('../components/macrotype/Layout'),
  redirect: { name: 'MacroTypeList' },
  meta: {
    breadcrumb: 'macro.macrotypes',
  },
  children: [
    {
      name: 'MacroTypeList',
      path: '',
      component: () => import('../views/macrotype/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'MacroTypeCreate',
      path: 'new',
      component: () => import('../views/macrotype/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'MacroTypeUpdate',
      path: ':id/edit',
      component: () => import('../views/macrotype/Update'),
      meta: {
        breadcrumb: 'macro.macrotype',
      },
    },
    {
      name: 'MacroTypeShow',
      path: ':id',
      component: () => import('../views/macrotype/Show'),
      meta: {
        breadcrumb: 'macro.macrotype',
      },
    }
  ]
};
